import {$, T} from "../../common/drupal/drupal";
/**
 * Class de gestion du header mobile
 */
class Header {

    /**
     * init
     */
    init(){
        $('.Header-burger').on('click', function() {
            $(this).closest('body').toggleClass('js-nav-opened');
        });
        // Replaces h2 in menu by another div
        const menuBlockTitle = document.querySelector('#block-menu-main-menu');
      if (menuBlockTitle) {
        let replacement = document.createElement('div');
        replacement.id = menuBlockTitle.id;
        replacement.innerHTML = menuBlockTitle.innerHTML;
        replacement.classList.add("visually-hidden");
        menuBlockTitle.parentNode.replaceChild(replacement, menuBlockTitle);
      }
    }



    /**
     * Attach.
     * @param context
     */
    attach(context) {
        if (T.contextIsRoot(context)) {
            this.init();
        }
    }
}

export let header = new Header();
